<template>
  <div>
    <div class="md-layout" v-if="false">
      <md-button class="md-dense md-primary" v-on:click="botao_voltar" v-if="botao_voltar_visible">
        <md-icon>arrow_back</md-icon>Voltar para lista
      </md-button>
    </div>
    <div class="md-layout" v-if="show_message == 'on' ">
      <div class="alert alert-success">{{message_text}}</div>
    </div>

    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Dados Básicos</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cliente</label>
              <div class="md-layout-item md-size-80 md-xsmall-size-70">
                <md-field>
                  <autocomplete
                    v-if="false"
                    search_method="clientes"
                    field_value="id"
                    field_text="nome"
                    :onSelect="OnSelectCliente"
                    :id_start_value="form.id_cliente"
                  ></autocomplete>

                  <vue_select
                    class="vue-select2"
                    name="select2"
                    :options="items_clientes"
                    v-model="form.id_cliente"
                    :searchable="true"
                    language="pt-BR"
                    :placeholder="placeholder_cliente"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_cliente') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Nome</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="nome"
                    type="text"
                    placeholder="Nome"
                    v-model="form.nome"
                    maxlength="300"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('nome') }}</span>
              </div>
              <label class="md-layout-item md-xsmall-size-30 md-form-label visible-mob">CNPJ</label>
              <div class="md-layout-item md-size-30 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="cnpj"
                    type="text"
                    placeholder="CNPJ"
                    v-model="form.cnpj"
                    maxlength="300"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('cnpj') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Contato</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input name="contato" type="text" placeholder="Contato" v-model="form.contato"></md-input>
                </md-field>
              </div>
              <label class="md-layout-item md-xsmall-size-30 md-form-label visible-mob">E-mail</label>
              <div class="md-layout-item md-size-30 md-xsmall-size-70">
                <md-field>
                  <md-input name="email" type="text" placeholder="E-mail" v-model="form.email"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Celular</label>
              <div class="md-layout-item md-size-30 md-xsmall-size-70">
                <md-field>
                  <md-input name="celular" type="text" placeholder="Celular" v-model="form.celular"></md-input>
                </md-field>
              </div>
              <label class="md-layout-item md-xsmall-size-30 md-form-label visible-mob">Site</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input name="site" type="text" placeholder="Site" v-model="form.site"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Ramo de Atividade</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="ramo_atividade"
                    type="text"
                    placeholder="Ramo de Atividade"
                    v-model="form.ramo_atividade"
                  ></md-input>
                </md-field>
              </div>
              <label class="md-layout-item md-xsmall-size-30 md-form-label visible-mob">Fonte</label>
              <div class="md-layout-item md-size-30 md-xsmall-size-70">
                <md-field>
                  <md-input name="fone" type="text" placeholder="Fonte" v-model="form.fone"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout" v-if="form.data_cadastro != null">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Data de Cadastro</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>{{form.data_cadastro | date_show}}</md-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Endereço</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Logradouro:</label>
              <div class="md-layout-item md-size-60 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.endereco" type="text" maxlength="300"></md-input>
                </md-field>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Número:</label>
              <div class="md-layout-item md-size-10 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.numero" type="text" maxlength="10"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Bairro</label>
              <div class="md-layout-item md-size-40 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.bairro" type="text" maxlength="300"></md-input>
                </md-field>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Complemento</label>
              <div class="md-layout-item md-size-30 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.complemento" type="text" maxlength="100"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cidade</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.cidade" type="text" maxlength="300"></md-input>
                </md-field>
              </div>
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Estado</label>

              <div class="md-layout-item md-size-10 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.estado" type="text" maxlength="2"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">CEP</label>
              <div class="md-layout-item md-size-40 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.cep" type="text" maxlength="8"></md-input>
                </md-field>
              </div>
            </div>
            <br />
            <br />
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">Observações</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout-item md-size-100">
                <md-field>
                  <md-textarea name="obs" type="text" placeholder="Observações" v-model="form.obs"></md-textarea>
                </md-field>
              </div>

                  <div class="md-layout-item md-size-100">
                                       
                                                        <md-field>

                                                                                  <md-checkbox  v-model="publicar"
                                                                                  >Publicar automaticamente quando cadastro 
                                                                                     (auditoria, inspeção, documentação cliente) for realizado do APP Nutricionista</md-checkbox>
                                                                                  
                                                        </md-field>

                                 </div>
            </md-card-content>





          </md-card>




        </div>
      </div>

      <div class="md-layout-item md-size-100">
        <div class="btn-right">
          <md-button
            class="md-info"
            type="button"
            v-bind:disabled="disableButton"
            v-on:click="salvar"
          >Salvar</md-button>

          <md-button
            class="md-danger"
            type="button"
            v-bind:disabled="disableButton"
            v-if="form != null && form.id != null && form.id !='' && parseInt(form.id) > 0"
            v-on:click="excluir"
          >Excluir</md-button>
        </div>
      </div>

      <div class="md-layout" v-if="form != null && form.id != null && form.id != '' ">
        <div class="md-layout-item md-size-100">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">Nutricionistas</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <table class="responsive-table striped">
                <tr>
                  <td>
                    <b>Total: {{total_itens}}</b>
                  </td>
                  <td style="text-align: right">
                    <md-button
                      @click="show_modal_itens = true"
                      class="md-round md-just-icon md-info pull-right"
                      type="button"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>
                </tr>
              </table>

              <div class="md-layout-item md-size-100">
                <comp_nutricionista_list
                  v-if="show_sub_form"
                  :id_pai="form.id"
                  tabela="estabelecimento"
                  :Loaded="onLoadedItens"
                ></comp_nutricionista_list>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <!-- :onPreSave="onPreSaveContatos"  :onSave="onPosSaveContatos" -->

      <modal
        v-if="form != null && form.id != null && form.id != '' && show_modal_itens"
        @close="show_modal_itens = false"
      >
        <div slot="body">
          <comp_nutricionista_cad
            :onPreSave="onPreSaveItens"
            :onSave="onPosSaveItens"
            :id_pai="form.id"
            tabela="estabelecimento"
          ></comp_nutricionista_cad>
        </div>
      </modal>

      <md-dialog :md-active.sync="showDialogError">
        <md-tabs md-dynamic-height>
          <md-tab md-label="Erros">
            <ul class="list-group" v-if="p_validator.errors != null ">
              <li
                v-for="(item, index) in p_validator.errors"
                class="list-group-item"
                :key="index"
                style="text-align: left"
              >{{item.msg}}</li>
            </ul>
            <center>
              <md-button class="md-danger" type="button" @click="hideModal">OK</md-button>
            </center>
          </md-tab>
        </md-tabs>
      </md-dialog>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import serviceCliente from "../../../services/ClienteService";
import service from "../../../services/EstabelecimentoService";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";
import comp_nutricionista_list from "../nutricionista/comp_nutricionista_list";
import comp_nutricionista_cad from "../nutricionista/comp_nutricionista_cad";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";
import Util from "../../../library/Util";

export default {
  components: {
    autocomplete,
    filelogo,
    modal,
    comp_nutricionista_cad,
    comp_nutricionista_list,
    vue_select
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  data() {
    return {
      acao: "Cadastrar",
      form: service.getModel(),
      dates: { data_cadastro: null },
      perfis: [],
      clientes: [],
      clientes_list: [],
      items_clientes: [],

      publicar: false,

      show_perfil: false,
      file_upload: null,

      botao_voltar_visible: true,

      loading: true,

      result2: "",
      disableButton: false,

      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,

      msg_status: "Carregando",

      show_modal_contacts: false,
      show_sub_form: true,
      show_autocompletes: true,

      show_modal_itens: false,
      show_sub_form: true,
      total_itens: 0,
      placeholder_cliente: "..Carregando clientes"
    };
  },
  mounted() {
    let self = this;

    // this.$material.locale.dateFormat = "DD/MM/YYYY";

    this.configureMessages();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    serviceCliente.getList2("", "nome", "asc").then(function(response) {
      self.items_clientes = Util.getListToSelect(
        response.data.data,
        "id",
        "nome"
      );

      self.placeholder_cliente = "Cliente (digite para pesquisar) ";
    });

    this.disableButton = true;

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      self.show_autocompletes = false;

      service.getById(this.id_load).then(function(response) {
        self.form = response.data.item;
        self.publicar = self.form.pub_automatico == 1;
        //self.dates.data_cadastro = new Date( Date.parse( self.form.data_cadastro ));
        self.loading = false;
        self.disableButton = false;
        self.show_autocompletes = true;

        self.ajusta_cep();
      });
    } else {
      this.loading = false;
      this.disableButton = false;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "estabelecimento",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    ajusta_cep() {
      if (this.form.cep_str != null && this.form.cep_str.length > 1) {
        this.form.cep = this.form.cep_str.replace("#", "");
      }
    },

    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    OnSelectCliente(item) {
      if (item != null && item.id != null) {
        this.form.id_cliente = item.id;
      } else {
        this.form.id_cliente = null;
      }
    },
    changed(prop) {},
    onLoadedItens(qtde) {
      this.total_itens = qtde;
    },
    onPreSaveItens() {
      this.show_sub_form = false;
    },
    onPosSaveItens(itens) {
      this.show_sub_form = true;
    },

    configureMessages() {
      const dict = {
        // email: {
        //   required: 'O e-mail não pode ser vazio!',
        //   email: 'É necessário informar um e-mail válido!'
        // },
        nome: {
          required: "Nome não pode ser vazio!"
        },
        id_cliente: {
          required: "Cliente não pode ser vazio!",
          internal: true
        }
        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },
    salvar() {
      var self = this;

      if (!this.validar()) return false;

      self.msg_status = "Salvando..";
      self.loading = true;

      this.form.pub_automatico = this.publicar ? 1 : 0;

      if (this.form["nome"] == null) {
        //alert("Dado indo inválido!");
        //return;
      }

      service
        .salvar(this.form)
        .then(function(response) {
          var retorno = response.data;

          self.show_message = "on";
          self.message_text = "Unidades salvo com sucesso!";

          self.interval_message = setInterval(self.clear_message, 6000);

          var item = retorno.item;

          self.msg_status = "Carregando..";
          self.loading = false;

          self.form = item;

          self.ajusta_cep();

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
        })
        .catch(function(error) {});
    },

    excluir() {
      let self = this;
      self.msg_status = "Excluindo..";
      self.loading = true;

      var fn_return = function(response) {
        var retorno = response.data;
        if (self.onSave != null && self.onSave != undefined) {
          self.onSave(retorno, "delete");
        }
        self.msg_status = "Carregando..";
        self.loading = false;
        self.botao_voltar();
      };
      if (this.form.id == null) return false;

      service.delete(this.form.id).then(fn_return);
      //	obj_api.call_delete("cliente", this.id, fn_return);
    },
    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>